import React from 'react';
import { useSelector } from 'react-redux';
import { getToastData } from '../../core/redux/toast/selectors';
import ToastService from '../../service/toast-service';
import { useDispatch } from 'react-redux';
import { actions as toastActions } from '../../core/redux/toast/slice';

const { removeToast } = toastActions;

/** Avoid "Objects are not valid as a React child" when toast message is a nested API error object. */
const safeToastText = (message, fallback = 'Something went wrong') => {
  if (message == null || message === '') return fallback;
  if (typeof message === 'string') {
    const t = message.trim();
    return t || fallback;
  }
  if (typeof message === 'number' || typeof message === 'boolean') return String(message);
  if (typeof message === 'object') {
    const nested = message.message ?? message.Message ?? message.errorMessage;
    if (nested != null && nested !== message) return safeToastText(nested, fallback);
    try {
      return JSON.stringify(message);
    } catch {
      return fallback;
    }
  }
  return String(message);
};

const ToastMessage = () => {
  const toasts = useSelector(getToastData);
  const dispatch = useDispatch();

  return (
    <div className={`toast-container position-fixed top-0 end-0 p-3`}>
      {toasts.map(toast => {
        const { id, message, type } = toast;
        const text = safeToastText(message);

        const onClose = () => {
          dispatch(removeToast(id));
        };

        const renderToast = () => {
          switch (type) {
            case ToastService.types.SUCCESS:
              return ToastService.success(text, { key: id, onClose });
            case ToastService.types.DANGER:
              return ToastService.error(text, { key: id, onClose });
            case ToastService.types.WARNING:
              return ToastService.warning(text, { key: id, onClose });
            case ToastService.types.INFO:
              return ToastService.info(text, { key: id, onClose });
            default:
              return ToastService.createToast(text, { key: id, onClose });
          }
        };

        return (
          <div className="toast-item p-2" key={id}>
            {renderToast()}
          </div>
        );
      })}
    </div>
  );
};

export default ToastMessage;
